<article class="keyword-layout {{ class ?? '' }} {{ linkPopup ? 'link' : '' }} {{ fullWord ? 'full-word' : '' }}"
         *ngIf="word">

  <!-- #container 의 위치는 컴포넌트의 가장 상위 첫번째 child이어야 함 -->
  <ng-container #container></ng-container>

  <!-- 기본 모드: 한글+한자 한 줄 -->
  <div class="keyword-wrap" *ngIf="!effectiveWrap">

    <div class="group {{ GetCharClass(cs) }}"
         *ngFor="let cs of word?.wordStruct; let idx = index">
      <div class="row top {{ GetTopRowClass(cs) }} {{ large ? 'large' : '' }}"
           *ngIf="IsShowSeungjo(cs) || GetTopRowClass(cs)">
        <div *ngIf="IsShowSeungjo(cs)"
             class="ic {{ GetSeungjoClass2(cs) }}">
        </div>
      </div>
      <div class="row txt {{ GetCharClass(cs) }} {{ large ? 'large' : '' }} {{ GetHightlightClass(idx) }}">
        <app-hanja-char *ngIf="IsHanja(cs) && hanjaLink; else notHanja"
                        [hanja]="GetCharTxt(cs)"></app-hanja-char>
        <ng-template #notHanja>{{ GetCharTxt(cs) }}</ng-template>
      </div>
    </div>

    <div class="group" *ngIf="word.idxHomonym > 0">
      <div class="row top {{ large ? 'large' : '' }}"></div>
      <div class="row txt idx-homonym {{ large ? 'large' : '' }}">{{ word.idxHomonym }}</div>
    </div>

  </div>
  <ng-container *ngIf="!effectiveWrap">
    <ng-container *ngTemplateOutlet="correctRow"></ng-container>
  </ng-container>

  <!-- 줄 분리 모드: 공간 부족 시 한글과 한자를 별도 줄로 표시 -->
  <div class="wrap-hanja" *ngIf="effectiveWrap">
    <div class="keyword-wrap">
      <div class="group {{ GetCharClass(item.cs) }}"
           *ngFor="let item of hangulChars">
        <div class="row top {{ GetTopRowClass(item.cs) }} {{ large ? 'large' : '' }}"
             *ngIf="IsShowSeungjo(item.cs) || GetTopRowClass(item.cs)">
          <div *ngIf="IsShowSeungjo(item.cs)"
               class="ic {{ GetSeungjoClass2(item.cs) }}">
          </div>
        </div>
        <div class="row txt {{ GetCharClass(item.cs) }} {{ large ? 'large' : '' }} {{ GetHightlightClass(item.idx) }}">
          {{ GetCharTxt(item.cs) }}
        </div>
      </div>

      <div class="group" *ngIf="word.idxHomonym > 0">
        <div class="row top {{ large ? 'large' : '' }}"></div>
        <div class="row txt idx-homonym {{ large ? 'large' : '' }}">{{ word.idxHomonym }}</div>
      </div>

    </div>

    <div class="keyword-wrap" *ngIf="hanjaChars.length > 0">
      <div class="group"
           *ngFor="let item of hanjaChars">
        <div class="row top {{ GetTopRowClass(item.cs) }} {{ large ? 'large' : '' }}"
             *ngIf="GetTopRowClass(item.cs)">
        </div>
        <div class="row txt cn {{ large ? 'large' : '' }} {{ GetHightlightClass(item.idx) }}">
          <app-hanja-char *ngIf="hanjaLink; else notHanjaWrap"
                          [hanja]="item.cs.char"></app-hanja-char>
          <ng-template #notHanjaWrap>{{ item.cs.char }}</ng-template>
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="correctRow"></ng-container>
  </div>

  <ng-template #correctRow>
    <div class="correct-wrap" *ngIf="word?.correct">
      <div class="correct-cell arrow {{ large ? 'large' : '' }}">{{ arrowCorrect }}</div>
      <div class="correct-cell correct {{ large ? 'large' : '' }}">{{ wordCorrect }}</div>
    </div>
  </ng-template>

</article>
